import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';


import { RouterModule } from '@angular/router'; // Import RouterModule

import { AppComponent } from './app.component';
import { UiModule } from './ui/ui.module';
import { SharedModule } from "./shared/shared.module";

import { LoginComponent } from './auth/login/login.component';
import { ForgotComponent } from './auth/forgot/forgot.component';
import { RegisterComponent } from './auth/register/register.component';
import { UsersListComponent } from './users/users-list/users-list.component';
import { AccessListComponent } from './access/access-list/access-list.component';
import { AddAccessComponent } from './access/add-access/add-access.component';
import { EditUserComponent } from './users/edit-user/edit-user.component';
import { AddUserComponent } from './users/add-user/add-user.component';
import { ViewUserComponent } from './users/view-user/view-user.component';

import { StudyListComponent } from "./study/study-list/study-list.component";
import { StudyCRCListComponent } from "./study/study-crc-list/study-crc-list.component";
import { StudyViewComponent } from "./study/study-crc-view/study-crc-view.component";
import { EditStudyComponent } from './study/edit-study/edit-study.component';
import { ViewStudyComponent } from './study/view-visits/view-study.component';
import { StudyCRCEditComponent } from "./study/study-crc-edit/study-crc-edit.component";
import { StudyCRCMonitoringComponent } from "./study/study-crc-monitoring/study-crc-monitoring.component";

import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EmailLoginComponent } from './auth/email-login/email-login.component';
import { ExportexcelComponent } from './study/exportexcel/exportexcel.component';
import { PieChartComponent } from './pie-chart/pie-chart.component';

import { StudyDetailsComponent } from './study-details/study-details.component';
import { FoldersComponent } from './study/folders/folders.component';
import { ScreeningVisitsComponent } from './study/folders/screening-visits/screening-visits.component';
import { VisitsComponent } from './study/visits/visits.component';
import { BaselineVisitsComponent } from './study/folders/baseline-visits/baseline-visits.component';
import { MedicineDispensingVisitComponent } from './study/folders/medicine-dispensing-visit/medicine-dispensing-visit.component';
import { StudyCompletionTerminationComponent } from './study/folders/study-completion-termination/study-completion-termination.component';
import { FollowupVisitComponent } from './study/folders/follow-up-visit/follow-up-visit.component';
import { PrincipalInvestigatorSignatureComponent } from './study/folders/principal-investigator-signature/principal-investigator-signature.component';
import { ProtocolDeviationComponent } from './study/folders/protocol-deviation/protocol-deviation.component';
import { AdverseEventsComponent } from './study/folders/adverse-events/adverse-events.component';
import { ConcomitantMedicationLogComponent } from './study/folders/concomitant-medication-log/concomitant-medication-log.component';
import { RescueMedicationLogComponent } from './study/folders/rescue-medication-log/rescue-medication-log.component';
import { PriorMedicationLogComponent } from './study/folders/prior-medication-log/prior-medication-log.component';
import { MedicalHistoryComponent } from './study/folders/medical-history/medical-history.component';
import { VitalSignsComponent } from './study/folders/vital-signs/vital-signs.component';
import { PHYSICALANDSYSTEMICEXAMINATIONComponent } from './study/folders/physical-and-systemic-examination/physical-and-systemic-examination.component';
import { LaboratoryInvestigationComponent } from './study/folders/laboratory-investigation/laboratory-investigation.component';
import { IdrsComponent } from './study/folders/idrs/idrs.component';
import { ScheduleOfActivitiesComponent } from './study/folders/schedule-of-activities/schedule-of-activities.component';
import { DynamicFormComponent } from './study/folders/dynamic-form/dynamic-form.component';
import { BuildEcrfComponent } from './study/build-ecrf/build-ecrf.component';
import { EcrfTemplateComponent } from './study/ecrf-template/ecrf-template.component';
import { EcrfListComponent } from './study/ecrf-list/ecrf-list.component';
import { SiteListComponent } from './study/site-list/site-list.component';
import { StudyTemplateComponent } from './study/study-template/study-template.component';
import { AddLocationComponent } from './study/add-location/add-location.component';
import { DataViewComponent } from './study-management/data-view/data-view.component';
import { QueryViewComponent } from './study-management/query-view/query-view.component';
import { SubscriptionsComponent } from './study-management/subscriptions/subscriptions.component';
import { AuditTrailComponent } from './study-management/audit-trail/audit-trail.component';
import { SystemAuditTrailComponent } from './study-management/system-audit-trail/system-audit-trail.component';
import { InactivityWarningModalComponent } from './shared/inactivity-warning-modal/inactivity-warning-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    DynamicFormComponent,
    AppComponent,
    LoginComponent,
    ForgotComponent,
    RegisterComponent,
    UsersListComponent,
    AccessListComponent,
    AddAccessComponent,
    EditUserComponent,
    StudyListComponent,
    StudyCRCListComponent,
    StudyViewComponent,
    AddUserComponent,
    ViewUserComponent,
    EditStudyComponent,
    ViewStudyComponent,
    EmailLoginComponent,
    StudyCRCEditComponent,
    StudyCRCMonitoringComponent,
    ExportexcelComponent,
    PieChartComponent,
    StudyDetailsComponent,
    FoldersComponent,
   // FolderSidenavComponent,
    VisitsComponent,
    ScreeningVisitsComponent,
    BaselineVisitsComponent,
    MedicineDispensingVisitComponent,
    StudyCompletionTerminationComponent,
    FollowupVisitComponent,
    PrincipalInvestigatorSignatureComponent,
    ProtocolDeviationComponent,
    AdverseEventsComponent,
    ConcomitantMedicationLogComponent,
    PriorMedicationLogComponent,
    RescueMedicationLogComponent,
    MedicalHistoryComponent,
    VitalSignsComponent,
    PHYSICALANDSYSTEMICEXAMINATIONComponent,
    LaboratoryInvestigationComponent,
    IdrsComponent,
    ScheduleOfActivitiesComponent,
    BuildEcrfComponent,
    EcrfTemplateComponent,
    EcrfListComponent,
    SiteListComponent,
    StudyTemplateComponent,
    SubscriptionsComponent,
    DataViewComponent,
    QueryViewComponent,
    AuditTrailComponent,
    SystemAuditTrailComponent,
    InactivityWarningModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,

    RouterModule, // Add RouterModule here

    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    UiModule,
    SharedModule,
    NgSelectModule,
    AddLocationComponent,
    NgMultiSelectDropDownModule.forRoot(),
    DragDropModule,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
